import { FilterableColumns } from "../../components/common/filter/GridDataFilter";

export enum PARCEL_CENTER_COLUMN_NAME {
  PARCEL_CENTER_ID = "parcelCenterId",
  PARCEL_CENTER_NAME = "parcelCenterName",
  ADDRESS = "address",
  CITY = "city",
  STATE = "state",
  ZIPCODE = "zipCode",
  LATITUDE = "latitude",
  LONGITUDE = "longitude",
  TIME_ZONE = "timezone",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
}

export enum PARCEL_CENTER_LABEL_NAME {
  PARCEL_CENTER_ID = "Parcel Center Id",
  PARCEL_CENTER_NAME = "Name",
  ADDRESS = "Address",
  CITY = "City",
  STATE = "State",
  ZIPCODE = "Zip Code",
  LATITUDE = "Latitude",
  LONGITUDE = "Longitude",
  TIME_ZONE = "Time Zone",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
}

export const parcelCenterFilterColumns: FilterableColumns = {
  [PARCEL_CENTER_COLUMN_NAME.PARCEL_CENTER_ID]: {
    displayName: PARCEL_CENTER_LABEL_NAME.PARCEL_CENTER_ID,
    options: [],
    type: "number",
  },
  [PARCEL_CENTER_COLUMN_NAME.PARCEL_CENTER_NAME]: {
    displayName: PARCEL_CENTER_LABEL_NAME.PARCEL_CENTER_NAME,
    options: [],
    type: "string",
  },
  [PARCEL_CENTER_COLUMN_NAME.ADDRESS]: {
    displayName: PARCEL_CENTER_LABEL_NAME.ADDRESS,
    options: [],
    type: "string",
  },
  [PARCEL_CENTER_COLUMN_NAME.CITY]: {
    displayName: PARCEL_CENTER_LABEL_NAME.CITY,
    options: [],
    type: "string",
  },
  [PARCEL_CENTER_COLUMN_NAME.STATE]: {
    displayName: PARCEL_CENTER_LABEL_NAME.STATE,
    options: [],
    type: "string",
  },
  [PARCEL_CENTER_COLUMN_NAME.ZIPCODE]: {
    displayName: PARCEL_CENTER_LABEL_NAME.ZIPCODE,
    options: [],
    type: "string",
  },
  fdps: {
    displayName: "Associated Fdp(s)",
    options: [],
    type: "string",
  },
};
